import { getStackItemId, ItemsFolder } from '@pn/core/domain/workspace';
import type { IProjectMapper } from '@pn/core/mappers/project';
import type { StackProject } from './types';

export const apiStackProjectMapper: IProjectMapper<StackProject, never> = {
  toDomainProject: (stackProject) => {
    return {
      id: `stackdx|${stackProject.projectId}`,
      name: stackProject.description,
      folder: ItemsFolder.Stack,
      createdAt: stackProject.createDate,
      updatedAt: stackProject.updateDate,
      createdBy: undefined,
      workspaceItemIds: stackProject.lists
        .filter((list) => (list.count ?? 0) > 0)
        .sort(
          (a, b) =>
            preferredOrder.indexOf(b.dataType) -
            preferredOrder.indexOf(a.dataType)
        )
        .map((list) =>
          getStackItemId(stackProject.projectId, list.sourceLayerId)
        ),
      isFolder: true,
      isShared: false,
      isGlobal: false,
      origin: 'stackdx',
      metadata: {
        dataOriginDescription: stackProject.dataOriginDesc,
      },
    };
  },
  toTargetProjectPayload: () => {
    throw new Error('Manipulation of Stack projects is not supported');
  },
};

export const preferredOrder = [
  'wells',
  'wells_usa',
  'pipelines',
  'facilities',
  'contractSplits',
  'mineralSplits',
  'surface',
];
